import { useEffect, useState } from "react";

import Typography from "@/foundation/Typography/V2";

import {
    clsx,
    classNameGenerator,
    getTimeDifferenceFromNow,
    isDateInPast,
} from "@/utils";

import styles from "./OfferCountdownNew.module.scss";
import { SVGSprite } from "@/components/Atoms";
import { useAppSelector, useWindowDimensions } from "@/hooks";
import OfferCountdown from "../../TimerSection/TimeCounter/index"


interface OfferCountdownProps {
    label?: string;
    endDate: string;
    className?: string;
    icon?: string
}

const OfferCountdownNew: React.FC<OfferCountdownProps> = ({
    label,
    endDate,
    className,
    icon
}) => {
    const cls = classNameGenerator(styles);
    const { width } = useWindowDimensions();
    const [isDateHasPassed, setIsDateHasPassed] = useState(isDateInPast(endDate));

    const { data } = useAppSelector((state) => state.bootCamp);
    const  {offerSection} = data?.heroSection

    useEffect(() => {
        const interval = setInterval(() => {
            const timeObject = getTimeDifferenceFromNow(endDate);
            setIsDateHasPassed(timeObject?.seconds < 0);
        }, 1000);

        return () => clearInterval(interval);
    }, [endDate]);

    if (isDateHasPassed) {
        return <></>;
    }


    return (
        <div className={clsx(cls("offerCountdownNew"), className)}>
            <div className={cls("slots")}>
                <SVGSprite
                    className={cls("icon")}
                    icon={width < 600 ? "icon-white-fire" : "icon-fire"}
                />
                <span
                    className={cls("count")}
                >
                    {offerSection?.slots}
                </span>
                <Typography
                    variant="heading4"
                    className={cls("left")}
                    dangerouslySetInnerHTML={{ __html: "Slots left" }}
                />
            </div>
            <OfferCountdown
                endDate={endDate}
                className={cls("floatingBannerTimer")}
            />
        </div>
    );
};

export default OfferCountdownNew;
